
import { Model, Attr, BelongsTo, HasMany } from 'spraypaint'

import ApplicationRecord from '@/models/ApplicationRecord'
import { Customer, Card } from '@/models/index'

@Model()
export default class Gift extends ApplicationRecord {
  static jsonapiType = 'gifts'

  @Attr() id!: string
  @Attr() message!: string
  @Attr() createdAt!: string
  @Attr() updatedAt!: string
  @Attr() status!: string

  @BelongsTo() sender!: any
  @BelongsTo() recipient!: Customer

  @HasMany() cards!: Card[]

}
